import React, { useEffect } from 'react';

/**
 * Full-screen maintenance page — matches public/maintenance.html design.
 * SVG illustration is loaded as a static asset so animations are preserved.
 */
const MaintenancePage: React.FC = () => {
  useEffect(() => {
    document.title = "We'll Be Back Soon";
    const meta = document.querySelector('meta[name="robots"]');
    if (meta) {
      meta.setAttribute('content', 'noindex, nofollow');
    } else {
      const m = document.createElement('meta');
      m.name = 'robots';
      m.content = 'noindex, nofollow';
      document.head.appendChild(m);
    }
  }, []);

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@500;700;900&family=Inter:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <style>{`
        :root {
          --bg: #f6f5f3;
          --ink: #34343a;
          --ink-soft: #6d6e71;
          --line: #d9d8d4;
        }
        .maintenance-root {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
          background: var(--bg);
          font-family: 'Inter', sans-serif;
          color: var(--ink);
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
        }
        .maintenance-root * { box-sizing: border-box; }
        .maintenance-page {
          width: 100%;
          max-width: 1160px;
          text-align: center;
        }
        .maintenance-scene {
          width: 100%;
          max-width: 1100px;
          margin: 0 auto;
          animation: maintenance-scene-float 6s ease-in-out infinite;
        }
        .maintenance-scene object,
        .maintenance-scene img {
          width: 100%;
          height: auto;
          display: block;
          pointer-events: none;
        }
        @keyframes maintenance-scene-float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
        .maintenance-divider {
          width: 78%;
          max-width: 880px;
          height: 1px;
          background: var(--line);
          margin: -4px auto 24px;
        }
        .maintenance-root h1 {
          font-family: 'Roboto Slab', serif;
          font-weight: 700;
          font-size: clamp(24px, 3.4vw, 36px);
          margin: 0 0 10px;
          color: var(--ink);
        }
        .maintenance-root p.subtitle {
          font-size: 16px;
          color: var(--ink-soft);
          margin: 0;
          letter-spacing: 0.01em;
        }
        @media (prefers-reduced-motion: reduce) {
          .maintenance-scene { animation: none !important; }
        }
      `}</style>
      <div className="maintenance-root">
        <div className="maintenance-page">
          <div className="maintenance-scene">
            <object
              type="image/svg+xml"
              data="/maintenance-scene.svg"
              aria-label="Website under maintenance illustration"
            >
              <img src="/maintenance-scene.svg" alt="Website under maintenance" />
            </object>
          </div>
          <div className="maintenance-divider" />
          <h1>We&apos;ll Be Back Soon</h1>
          <p className="subtitle">website is temporarily unavailable.</p>
        </div>
      </div>
    </>
  );
};

export default MaintenancePage;
